import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["fontFamily"],
  _excluded2 = ["fontFamily"];
import styled from "@emotion/styled";
import { ttNormsFontFamily, ttNormsVarFontFamily } from "../../../fonts/fonts";
import { typeRampLodestarDefinitions } from "../constants/lodestarConstants";
import { ursaTypeRampDefinitions } from "../constants/ursaConstants";
import { TypeRampComponentBase } from "./TypeRampComponentBase";
function getKey(_ref) {
  var system = _ref.system,
    variant = _ref.variant;
  switch (system) {
    case "lodestar":
      return "".concat(system, "_").concat(variant);
    case "ursa":
      return "".concat(system, "_").concat(variant);
  }
}
var typeRampV2PrecomputedComponents = {};

// Pre-calc the Ursa variants as styled components. This is around a 10x performance improvement
// on trying to use the css prop or generating them on the fly.
for (var _i = 0, _Object$entries = Object.entries(ursaTypeRampDefinitions); _i < _Object$entries.length; _i++) {
  var _ref2 = _Object$entries[_i];
  var _ref3 = _slicedToArray(_ref2, 2),
    key = _ref3[0],
    _ref3$ = _ref3[1],
    fontFamily = _ref3$.fontFamily,
    styles = _objectWithoutProperties(_ref3$, _excluded);
  var Component = styled(TypeRampComponentBase)(_objectSpread(_objectSpread({}, styles), fontFamily === ttNormsFontFamily ? _defineProperty({
    fontFamily: ttNormsFontFamily
  }, "@supports (font-variation-settings: normal)", {
    fontFamily: ttNormsVarFontFamily
  }) : {}))
  // Without this, the React typings aren't happy. It REALLY wants to make sure it's a span.
  .withComponent("span");
  typeRampV2PrecomputedComponents["ursa_".concat(key)] = Component;
}

// Pre-calc the Lodestar variants as styled components. This is around a 10x performance improvement
// on trying to use the css prop or generating them on the fly.
for (var _i2 = 0, _Object$entries2 = Object.entries(typeRampLodestarDefinitions); _i2 < _Object$entries2.length; _i2++) {
  var _ref5 = _Object$entries2[_i2];
  var _ref6 = _slicedToArray(_ref5, 2),
    _key = _ref6[0],
    _ref6$ = _ref6[1],
    _fontFamily = _ref6$.fontFamily,
    _styles = _objectWithoutProperties(_ref6$, _excluded2);
  var _Component = styled(TypeRampComponentBase)(_objectSpread(_objectSpread({}, _styles), _fontFamily === "TT Norms Pro" ? _defineProperty({
    fontFamily: ttNormsFontFamily
  }, "@supports (font-variation-settings: normal)", {
    fontFamily: ttNormsVarFontFamily
  }) : {}))
  // Without this, the React typings aren't happy. It REALLY wants to make sure it's a span.
  .withComponent("span");
  typeRampV2PrecomputedComponents["lodestar_".concat(_key)] = _Component;
}
export var getTypeRampV2PrecomputedComponent = function getTypeRampV2PrecomputedComponent(systemAndVariant) {
  var key = getKey(systemAndVariant);
  return typeRampV2PrecomputedComponents[key];
};
//# sourceMappingURL=TypeRampV2PrecomputedComponents.js.map